<template>
    <img src="/images/promo/hero-section/hammer.png"
     alt="Hammer" />
</template>

<script>
export default {};
</script>
